import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'toggler-component',
  templateUrl: './toggler.component.html',
  styleUrls: ['./toggler.component.scss'],
})
export class TogglerComponent {
  @Input() public state: boolean;
  @Input() public label: string;
  @Input() public componentStyle: string;
  @Input() public disabled: boolean;
  @Input() public allowChange: boolean;
  @Output() public onChange: EventEmitter<boolean>;

  constructor() {
    this.state = false;
    this.label = '';
    this.componentStyle = '';
    this.disabled = false;
    this.allowChange = true;
    this.onChange = new EventEmitter<boolean>();
  }

  onClick() {
    if (this.allowChange) {
      this.state = !this.state;
    }
    this.onChange.emit(this.state);
  }
}
